import React from 'react';
import { useGetOptions, SelectInputProps } from "../../../../../hooks/report/useGetOptions";
import { BoundSelect } from "../BoundSelect";
import { PendingInventoryActivityStatus } from "../../../../constants/securspace-constants";

type BoundPendingInventoryActivityStatusSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundPendingInventoryActivityStatusSelect = <T,>({
  label = "Status",
  name,
  value = '',
  onChange
}: BoundPendingInventoryActivityStatusSelectProps<T>) => {

  return <BoundSelect<T>
    options={useGetOptions({optionFormat: 'SELECT', options: PendingInventoryActivityStatus}) as unknown as SelectInputProps[]}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundPendingInventoryActivityStatusSelect };